import "./AICitations.module.css";
import Header from "@/reusable_sections/Header";
import Aicitationsintro from "./sections/Aicitationsintro";
import Strategies from "./sections/Strategies";
import Calltoaction from "./sections/Calltoaction";
import Footer from "@/reusable_sections/Footer";
export default function AICitationsPage() {
  return <div>
      <Header />
      <Aicitationsintro />
      <Strategies />
      <Calltoaction />
      <Footer />
    </div>;
}